module.exports = __webpack_public_path__ + "img/6.a0662ef4.jpg";